<template>
    <nav class="navbar navbar-expand-lg navbar-bg">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img
            src="@/assets/logo.png"
            style="height: 60px;"
            alt=""
            @mouseover="changeLogoToGif"
            @mouseout="changeLogoToPng"
            ref="logoImg"
          />
          <span class="title-text"
            @mouseover="changeLogoToGif"
            @mouseout="changeLogoToPng">八斗故事村</span>
        </a>
        <button class="navbar-toggler " type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 ">
            <li v-for="(page, index) in pageList" class="nav-item" :class="{active: activePageNum == index}" :key="index">
              <a class="nav-link" @click="goToTargetPage(index)">
                {{ pageName[index] }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

  

<script>
export default {
  name: 'NavbarComponent',
  props: {
    activePage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pageList: ["Home", "Story", "About"],
      pageName: ["八斗里簡介", "實境解謎", "製作團隊"],
      activePageNum: 0
    };
  },
  created() {
    this.activePageNum = this.activePage;
    console.log("Active Page Number is " + this.activePage);
  },
  methods: {
    goToTargetPage(num) {
      this.$emit('updatePageIndex', num);
      this.activePageNum = num;
      this.$router.push({ name: this.pageList[num] });
      
    },
    changeLogoToGif() {
      this.$refs.logoImg.src = require('@/assets/flip.gif');
    },
    changeLogoToPng() {
      this.$refs.logoImg.src = require('@/assets/logo.png');
    }
  }
}
</script>
  

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100..900&display=swap');

.warp {
  font-weight: 600;
}

.nav-item {
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 600;
  font-size: 26px;
  margin-right: 2rem;
  background-color: transparent;
  cursor: pointer;
  position: relative;
  transition: all .3s linear;

  a {
    position: relative;
    z-index: 1;
    color: inherit;
    transition: color .3s linear;
  }
  
  &:hover {
    a {
      color: #7bcadd;
    }
    
    &::before {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  &::before {
    content: "";
    width: 0%;
    height: 0%;
    display: block;
    background-color: #ffffff;
    position: absolute;
    bottom: 0;
    right: 0;
    opacity: 0;
    transition: all .3s ease;
    transform: skewX(-30deg);
  }
}

.nav-item.active {
  background-color: #ffffff !important;

  a {
    color: #7bcadd;
  }

  &::before {
    transform: none;
    width: 100%;
    height: 100%;
    opacity: 1;
    background-color: #ffffff;
  }
}

.navbar {
  background-color: #7bcadd;
  padding: 1rem 6rem;

  span, a {
    color: #ffffff;
  }

  .navbar-brand {
    display: flex;
    span {
      font-family: "Noto Sans TC", sans-serif;
      font-size: 36px;
      margin-left: 1rem;
      text-align: center;
      justify-content: center;
    }
  }
}

@media (max-width: 992px) {
  .navbar {
    padding: 1rem 2rem;
  }
  .nav-item {
    padding: 0.2rem 1.5rem;
    margin-right: 0;
    margin-bottom: 1rem;
  }
  .nav-item:last-child {
    margin-bottom: 0;
  }
  .nav-item:first-child {
    margin-top: 1rem;
  }
}


</style>
